import { render, staticRenderFns } from "./FilterMainSource.vue?vue&type=template&id=64b8ec9e&scoped=true&"
import script from "./FilterMainSource.vue?vue&type=script&lang=js&"
export * from "./FilterMainSource.vue?vue&type=script&lang=js&"
import style0 from "./FilterMainSource.vue?vue&type=style&index=0&id=64b8ec9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8ec9e",
  null
  
)

export default component.exports